
import { defineComponent } from "vue";
import DoctorsList from "@/components/Departments/common/DoctorsListTemplate1.vue";
import { DepartmentPropDataInterface } from "@/ts/interfaces";

export default defineComponent({
  data(): DepartmentPropDataInterface {
    return {
      name: "Interventional Cardiology Doctors",
      queryName: "Interventional Cardiology",
      teamName: "Interventional Cardiology team",
    };
  },
  components: { DoctorsList },
});
